
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useAppDispatch, useAppSelector } from "../services/hooks";
import * as Yup from 'yup';
import { login, setAuthLoading } from "../stores/user/userSlice";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import FormBS from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next"; // Nazwa FormBS, aby uniknąć konfliktu z Formikiem

export default function LoginForm() {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const loginError = useAppSelector((state) => state.user.auth.errorInfo);

    // Schemat walidacji Yup
    const validationSchema = Yup.object({
        login: Yup.string()
            .email('Wprowadź poprawny email podany przy rejestracji')
            .required('Pole jest wymagane'),
        passwd: Yup.string()
            .min(8, 'Hasło musi mieć co najmniej 8 znaków')
            /* .matches(/[a-z]/, 'Wprowadź poprawne hasło podane przy rejestracji')
            .matches(/[A-Z]/, 'Wprowadź poprawne hasło podane przy rejestracji')
            .matches(/\d/, 'Wprowadź poprawne hasło podane przy rejestracji')
            .matches(/[\W_]/, 'Wprowadź poprawne hasło podane przy rejestracji') */
            .required('Pole jest wymagane'),
    });

    // Obsługa wysłania formularza
    const handleSubmit = async (values: { login: string, passwd: string }) => {
        dispatch(setAuthLoading(true))

        const formData = new FormData();
        formData.append('login', values.login);
        formData.append('passwd', values.passwd);

        dispatch(login(formData))
        return false;
    };

    return (
        <Formik
            initialValues={{ login: '', passwd: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ handleChange, handleBlur, values }) => (
                <Form /* className="w-50 mx-auto p-4 border rounded" */>
                    <Row className='gap-4'>
                        <Col xs={12} className='position-relative'>
                            <FormBS.Group>
                                <FormBS.Label className="form-label-basket">Adres e-mail</FormBS.Label>
                                <Field
                                    name="login"
                                    type="email"
                                    className="form-control rounded-3 focus-ring focus-ring-warning border-secondary-subtle"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.login}
                                    placeholder="Wprowadź adres e-mail"
                                />
                                <ErrorMessage
                                    name="login"
                                    component="div"
                                    className="text-danger"
                                />
                            </FormBS.Group>
                            {/* <div id="ajaxResponseMessage" className="col-12" style={{ height: "10px" }}></div> */}
                        </Col>
                        <Col xs={12} className='position-relative'>
                            <FormBS.Group className="mb-3">
                                <FormBS.Label className="form-label-basket">Hasło</FormBS.Label>
                                <Field
                                    name="passwd"
                                    type="password"
                                    className="form-control rounded-3 focus-ring focus-ring-warning border-secondary-subtle"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.passwd}
                                    placeholder="Wprowadź hasło"
                                />
                                <ErrorMessage
                                    name="passwd"
                                    component="div"
                                    className="text-danger"
                                />
                                <a className="btn w-auto mx-auto d-block rounded-3" href="/reset-password">Nie pamiętasz hasła?</a>
                            </FormBS.Group>
                        </Col>
                        <div className="col-12 align-items-center text-center">
                            {loginError ? <div id="loginErrorMessage" className="text-danger">Wystąpił
                                błąd: {loginError}</div> : ''}
                            <button type="submit" className="btn btn-success rounded-3">{t('header.modal.account.login')}</button>
                        </div>
                    </Row>
                </Form>
            )}
        </Formik>
    );
};